import { render, staticRenderFns } from "./ClassroomStreamMain.vue?vue&type=template&id=6d107d44&scoped=true&"
import script from "./ClassroomStreamMain.vue?vue&type=script&lang=js&"
export * from "./ClassroomStreamMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d107d44",
  null
  
)

export default component.exports